import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { banUser } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom],
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        uids: '',
        server_id: '',
        is_abnormal_op: '',
        expire_time: '',
        reason: '',
        op_type: 1
      },
      isForever: false,
      whetherNot: [{
        label: '是',
        value: true
      }, {
        label: '否',
        value: false
      }],
      rules: {
        // op_type: [{ required: true, message: "请选择封禁时间", trigger: "blur" }],
        uids: [{
          required: true,
          message: "请输入原因",
          trigger: "blur"
        }],
        expire_time: [{
          required: true,
          message: "请选择封禁时间",
          trigger: "blur"
        }],
        reason: [{
          required: true,
          message: "请输入原因",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data, type) {
      this.paramsData.is_abnormal_op = type;
      this.paramsData.uids = data.role_id || '';
      this.paramsData.server_id = data.server_id || '';
      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        id: this.paramsData.id,
        uids: '',
        expire_time: '',
        // isForever: false,
        reason: '',
        op_type: 1
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this.paramsData));
          data.expire_time = data.isForever ? 0 : data.expire_time;
          data.uids = [data.uids];
          banUser(_objectSpread({}, data)).then(function (res) {
            if (res.code == 200 || res.status == 200) {
              _this.$message({
                message: '操作成功',
                type: 'success'
              });

              _this.dialogShow = false;

              _this.$emit('change', data.uids);
            }
          }).finally(function () {
            _this.issubmit = false;
          });
        }
      });
    }
  }
};